function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4 20.5c-.6 0-1-.4-1-1C3 17.6 4.6 16 6.5 16H20c.6 0 1 .4 1 1s-.4 1-1 1H6.5c-.8 0-1.5.7-1.5 1.5 0 .6-.4 1-1 1z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20 23H6.5C4.6 23 3 21.4 3 19.5v-15C3 2.6 4.6 1 6.5 1H20c.6 0 1 .4 1 1v20c0 .6-.4 1-1 1zM6.5 3C5.7 3 5 3.7 5 4.5v15c0 .8.7 1.5 1.5 1.5H19V3z"
});

function SvgIconBook(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyNCAyNCIgdmlld0JveD0iMCAwIDI0IDI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Im00IDIwLjVjLS42IDAtMS0uNC0xLTEgMC0xLjkgMS42LTMuNSAzLjUtMy41aDEzLjVjLjYgMCAxIC40IDEgMXMtLjQgMS0xIDFoLTEzLjVjLS44IDAtMS41LjctMS41IDEuNSAwIC42LS40IDEtMSAxeiIvPjxwYXRoIGQ9Im0yMCAyM2gtMTMuNWMtMS45IDAtMy41LTEuNi0zLjUtMy41di0xNWMwLTEuOSAxLjYtMy41IDMuNS0zLjVoMTMuNWMuNiAwIDEgLjQgMSAxdjIwYzAgLjYtLjQgMS0xIDF6bS0xMy41LTIwYy0uOCAwLTEuNS43LTEuNSAxLjV2MTVjMCAuOC43IDEuNSAxLjUgMS41aDEyLjV2LTE4eiIvPjwvc3ZnPg==";
export { SvgIconBook as ReactComponent };